import type { PresentationTarget, Rectangle } from '../../../renderer/src/video-presentation';
export type ChromeDensity = 'normal' | 'busy';
export interface ChromeRegion { name: string; kind: 'account' | 'caption' | 'actions' | 'playback'; bounds: Rectangle }

/** Representative English/LTR organic interface examples, rather than platform guarantees. */
export function chromeRegions(target: PresentationTarget, width: number, height: number, density: ChromeDensity): ChromeRegion[] {
  if (target === 'none') return [];
  const busy = density === 'busy';
  const feed = target === 'instagram-feed';
  const stories = target === 'instagram-stories';
  const shortFeed = feed && width / height > .6;
  const accountHeight = (feed ? busy ? .21 : .13 : busy ? .18 : .09) * height;
  const captionTop = (shortFeed ? busy ? .78 : .925 : busy ? .53 : .70) * height;
  const regions: ChromeRegion[] = [
    { name: 'Account and audio labels', kind: 'account', bounds: { x: .015 * width, y: .015 * height, width: .97 * width, height: accountHeight } },
    { name: stories ? 'Reply controls' : 'Caption and audio labels', kind: 'caption',
      bounds: { x: .025 * width, y: captionTop, width: (stories || shortFeed ? .95 : .73) * width, height: height * (shortFeed ? .06 : busy ? .39 : .20) } },
    { name: 'Playback controls', kind: 'playback', bounds: { x: 0, y: .98 * height, width, height: .02 * height } },
  ];
  if (!stories && !shortFeed) regions.push({ name: 'Action buttons', kind: 'actions', bounds: {
    x: (target === 'tiktok' || target === 'youtube-shorts' ? .84 : .88) * width,
    y: (busy ? .26 : .36) * height, width: .10 * width, height: .33 * height,
  } });
  return regions;
}
